import ProfileMobileView from "./profileMobileView";
import ProfileWebView from "./profileWebView";

const ProfileLayout = () => {
    return (
        <>
            <ProfileWebView />
            <ProfileMobileView />
        </>
    );
}

export default ProfileLayout;